import { CartSnapshot } from "@dashboard/cartVisibility/types";
import SearchInput from "@dashboard/components/AppLayout/ListFilters/components/SearchInput";
import { TopNav } from "@dashboard/components/AppLayout/TopNav";
import { DashboardCard } from "@dashboard/components/Card";
import { ListPageLayout } from "@dashboard/components/Layouts";
import { ListProps, SortPage } from "@dashboard/types";
import { Box } from "@saleor/macaw-ui-next";
import { FC } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { CartVisibilityListDatagrid } from "../CartVisibilityListDatagrid";
import { CartVisibilityListSortField } from "../CartVisibilityListDatagrid/datagrid";
import { messages } from "./messages";

interface CartVisibilityListPageProps extends ListProps, SortPage<CartVisibilityListSortField> {
  carts: CartSnapshot[];
  initialSearch: string;
  onSearchChange: (value: string) => void;
  onRowClick: (id: string) => void;
  onTakeOver: (token: string) => void;
  onOpenDraft: (id: string) => void;
}

export const CartVisibilityListPage: FC<CartVisibilityListPageProps> = ({
  carts,
  disabled,
  settings,
  sort,
  onSort,
  initialSearch,
  onSearchChange,
  onUpdateListSettings,
  onRowClick,
  onTakeOver,
  onOpenDraft,
}) => {
  const intl = useIntl();
  const subtitle = disabled
    ? undefined
    : intl.formatMessage(messages.subtitle, { count: carts.length });

  return (
    <ListPageLayout>
      <TopNav
        title={<FormattedMessage {...messages.title} />}
        subtitle={subtitle}
        withoutBorder
        isAlignToRight={false}
      />
      <DashboardCard>
        <Box
          display="flex"
          flexDirection="column"
          width="100%"
          alignItems="stretch"
          justifyContent="space-between"
        >
          <Box
            display="grid"
            __gridTemplateColumns="auto 1fr"
            gap={4}
            paddingBottom={2}
            paddingX={6}
          >
            <Box display="flex" alignItems="center" gap={4}>
              <Box __width="320px">
                <SearchInput
                  initialSearch={initialSearch}
                  placeholder={intl.formatMessage(messages.searchPlaceholder)}
                  onSearchChange={onSearchChange}
                />
              </Box>
            </Box>
          </Box>
        </Box>
        <CartVisibilityListDatagrid
          carts={carts}
          disabled={disabled}
          settings={settings}
          sort={sort}
          onSort={onSort}
          onUpdateListSettings={onUpdateListSettings}
          onRowClick={onRowClick}
          onTakeOver={onTakeOver}
          onOpenDraft={onOpenDraft}
          hasRowHover
        />
      </DashboardCard>
    </ListPageLayout>
  );
};
